function isTokenValid(token_name) {
    try {
        const token = localStorage.getItem(token_name);
        if (!token) return false;

        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c =>
            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        ).join(''));

        const payload = JSON.parse(jsonPayload);

        // Validate expiration
        const currentTime = Math.floor(Date.now() / 1000);
        if (!payload.exp || payload.exp < currentTime) {
            console.log("Token date expire");
            return false;
        };

        // Validate presence of id 
        if (!payload.id) {
            console.log("no id");
            return false
        };

        return true;
    } catch (error) {
        console.log('Token validation error:', error);
        return false;
    }
}


function getPayload(token_name) {

    const token = localStorage.getItem(token_name);
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));

    const payload = JSON.parse(jsonPayload);
    return payload;
}



export {isTokenValid, getPayload}